import script from "./DataModelSelectEntity.vue?vue&type=script&setup=true&lang=js"
export * from "./DataModelSelectEntity.vue?vue&type=script&setup=true&lang=js"

import "./DataModelSelectEntity.vue?vue&type=style&index=0&id=5011042d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5011042d"]])

export default __exports__